import { render, staticRenderFns } from "./Tab2Component.vue?vue&type=template&id=18fc895a&scoped=true&"
import script from "./Tab2Component.vue?vue&type=script&lang=js&"
export * from "./Tab2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc895a",
  null
  
)

export default component.exports